/* eslint-disable */
import { observable, action, transaction } from 'mobx'
import moment from 'moment'
import qs from 'qs'
import axios from 'axios'

import Auth from './Auth'

import config from '../config'

class Stats {
  @observable revenue = {}
  @observable traffic = {}

  @action
  getRevenueReport = (comId, date) => {
    const sDate = moment(date)
      .startOf('month')
      .format('YYYY-MM-DD')
    const eDate = moment(date)
      .endOf('month')
      .format('YYYY-MM-DD')
    const range = `${sDate}|${eDate}`

    return axios({
      method: 'get',
      url: `${config.api_uri}/stats/${comId}/revenue?date_range=${range}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        this.revenue = {
          ...this.revenue,
          [comId]: [...res.data.data]
        }

        return res.data.data
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  getBatchRevenueReport = date => {
    let sDate = moment(...(date ? [date] : []))

    if (!date) {
      sDate = sDate.subtract(10, 'years')
    }

    sDate = sDate.startOf('month').format('YYYY-MM-DD')

    const eDate = moment(date)
      .endOf('month')
      .format('YYYY-MM-DD')
    const range = `${sDate}|${eDate}`

    return axios({
      method: 'get',
      url: `${config.api_uri}/stats/*/revenue?date_range=${range}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        this.revenue = {
          ...this.revenue,
          ...res.data.data
        }

        return res.data.data
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  getTrafficReport = (comId, date) => {
    const sDate = moment(date)
      .startOf('month')
      .format('YYYY-MM-DD')
    const eDate = moment(date)
      .endOf('month')
      .format('YYYY-MM-DD')
    const range = `${sDate}|${eDate}`

    return axios({
      method: 'get',
      url: `${config.api_uri}/stats/${comId}/traffic?date_range=${range}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        this.traffic = {
          ...this.traffic,
          [comId]: [
            ...res.data.data.reduce((arr, t) => {
              const geoIndex = arr.findIndex(
                g => g.countryCode === t.countryCode && g.date === t.date
              )

              return [
                ...(geoIndex > -1
                  ? [
                      ...arr.slice(0, geoIndex),
                      t.id > arr[geoIndex].id ? t : arr[geoIndex],
                      ...arr.slice(geoIndex + 1)
                    ]
                  : [...arr, t])
              ]
            }, [])
          ]
        }

        return res.data.data
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  getBatchTrafficReport = date => {
    let sDate = moment(...(date ? [date] : []))

    if (!date) {
      sDate = sDate.subtract(10, 'years')
    }

    sDate = sDate.startOf('month').format('YYYY-MM-DD')

    const eDate = moment(date)
      .endOf('month')
      .format('YYYY-MM-DD')
    const range = `${sDate}|${eDate}`

    return axios({
      method: 'get',
      url: `${config.api_uri}/stats/*/traffic?date_range=${range}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        this.traffic = {
          ...this.traffic,
          ...res.data.data
        }

        return res.data.data
      })
      .catch(e => {
        console.warn(e)
      })
  }
}

export default new Stats()



// WEBPACK FOOTER //
// ./src/stores/Stats.js